import * as moment from "moment";

export function generarTurnos(
  horaInicio: string,
  horaFin: string,
  duracionTurno: string
): string[] {
  const turnos: string[] = [];

  if (!horaInicio || !horaFin || !duracionTurno) {
    return turnos;
  }
  const [inicioHoras, inicioMinutos] = horaInicio?.split(":")?.map(Number);
  const [finHoras, finMinutos] = horaFin?.split(":")?.map(Number);
  const [duracionHoras, duracionMinutos] = duracionTurno
    ?.split(":")
    ?.map(Number);

  let currentHoras = inicioHoras;
  let currentMinutos = inicioMinutos;

  while (
    currentHoras < finHoras ||
    (currentHoras === finHoras && currentMinutos < finMinutos)
  ) {
    const siguienteHoras =
      currentHoras +
      duracionHoras +
      Math.floor((currentMinutos + duracionMinutos) / 60);
    const siguienteMinutos = (currentMinutos + duracionMinutos) % 60;

    if (
      siguienteHoras > finHoras ||
      (siguienteHoras === finHoras && siguienteMinutos > finMinutos)
    ) {
      break;
    }

    const turnoInicio = `${String(currentHoras).padStart(2, "0")}:${String(
      currentMinutos
    ).padStart(2, "0")}`;
    const turnoFin = `${String(siguienteHoras).padStart(2, "0")}:${String(
      siguienteMinutos
    ).padStart(2, "0")}`;
    turnos.push(`${turnoInicio} - ${turnoFin}`);

    currentHoras = siguienteHoras;
    currentMinutos = siguienteMinutos;
  }

  return turnos;
}

export const diasSemanaOrdenAnglo = [
  "domingo",
  "lunes",
  "martes",
  "miercoles",
  "jueves",
  "viernes",
  "sabado",
];

export function tramosDelDiaAgenda(
  agenda: any,
  diaKey: string
): Array<{ desde: string; hasta: string }> {
  const tramos: Array<{ desde: string; hasta: string }> = [];
  const desde1 = agenda?.[`${diaKey}_desde`];
  const hasta1 = agenda?.[`${diaKey}_hasta`];
  if (desde1 && hasta1) tramos.push({ desde: desde1, hasta: hasta1 });
  const desde2 = agenda?.[`${diaKey}_desde_2`];
  const hasta2 = agenda?.[`${diaKey}_hasta_2`];
  if (desde2 && hasta2) tramos.push({ desde: desde2, hasta: hasta2 });
  return tramos;
}

export function generarSlotsParaDia(
  day: Date,
  agenda: any | null,
  diaActual: Date,
  duracion: string
): string[] {
  const esHoy = day.toDateString() === diaActual.toDateString();
  const horaActual = diaActual.getHours();

  if (agenda === null) {
    const desdeConControlDeHora = esHoy ? `${horaActual + 1}:00` : "00:00";
    return generarTurnos(desdeConControlDeHora, "24:00", duracion);
  }

  const diaKey = diasSemanaOrdenAnglo[day.getDay()];
  const slots: string[] = [];
  for (const tramo of tramosDelDiaAgenda(agenda, diaKey)) {
    let desdeConControlDeHora = tramo.desde;
    if (esHoy) {
      const horaDesde = Number(tramo.desde.split(":")[0]);
      if (horaActual > horaDesde) desdeConControlDeHora = `${horaActual + 1}:00`;
    }
    slots.push(...generarTurnos(desdeConControlDeHora, tramo.hasta, duracion));
  }
  return slots;
}

export function slotsLibres(
  slots: string[],
  turnos: any[],
  day: Date,
  idExcluir?: number
): string[] {
  const fecha = moment(day).format("YYYY-MM-DD");
  const aMinutos = (hora: string) => {
    const [h, m] = hora.trim().split(":").map(Number);
    return h * 60 + m;
  };
  const ocupados = turnos
    .filter((t) => t.id !== idExcluir && t.fecha_desde.startsWith(fecha))
    .map((t) => {
      const desde = aMinutos(t.fecha_desde.split(" ")[1]);
      return [desde, Math.max(aMinutos(t.fecha_hasta.split(" ")[1]), desde + 1)];
    });
  return slots.filter((slot) => {
    const [desde, hasta] = slot.split("-").map(aMinutos);
    return !ocupados.some(([d, h]) => d < hasta && h > desde);
  });
}
